import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class SharedSubjectService {
  rightPropToDashboard: Subject<any> = new Subject<any>();
  dashboardToRightProp: Subject<any> = new Subject<any>();

  constructor() {}
}
